export enum AuthStatus {
  OK,
  WRONG_CREDENTIALS,
  INVALID_FORMAT,
  EMAIL_UNAVAILABLE,
  ERROR,
  EMAIL_NOT_VALIDATED,
}
